import AxiosClient from "../../../services/axios.services";

class EvaluationTypeServices {
  getEvaluationType = (params) =>
    AxiosClient.get("/api/app/evaluacion_tipo_evaluacion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getEvaluationTypeById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_tipo_evaluacion/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveEvaluationType = (data) =>
    AxiosClient.post("/api/app/evaluacion_tipo_evaluacion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editEvaluationType = (id, data) =>
    AxiosClient.put(`/api/app/evaluacion_tipo_evaluacion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteEvaluationType = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_tipo_evaluacion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new EvaluationTypeServices();
